import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Notification } from 'constants/notifications.constants';
import _ from 'lodash';

interface notificationsState {
	data: Notification[];
}

const initialState: notificationsState = {
	data: [],
};

export const notificationsSlice = createSlice({
	name: 'notifications',
	initialState,
	reducers: {
		setCompanyNotifications: (state, action: PayloadAction<Notification[]>) => {
			state.data = action.payload;
		},
	},
});

export const { setCompanyNotifications } = notificationsSlice.actions;

export const getNotifications = (state: any) => state.notifications.data;

export default notificationsSlice.reducer;
